import React, { useContext } from 'react'
import FormContext from '../context/formContext';
import BackLogout from '../component/backLogout';

const FeesSubmitted = () => {

    const context = useContext(FormContext);
    const { previewlink } = context;

  return (
    <>
        <div className='container' style={{ height: "70vh" }}>

        <div>
        <BackLogout/>
      </div>

            <div className='row p-3'>
                <h2 className='text-center'>You have already filled the form.</h2>
            </div>
            <div className='row p-3'>
                <div className='col-sm-12 col-md-12 d-flex justify-content-around my-1'>
                <button className='btn w-25 btn-outline-primary' onClick={(e) => window.open(previewlink, '_blank')}>Preview Form / Download Receipt</button>
                </div>
                {/* <div className='col-sm-12 col-md-6 d-flex justify-content-around my-1'>
                <button className='btn w-50 btn-outline-primary'>Download Admit Card</button>
                </div> */}
            </div>

        </div>
    </>
  )
}

export default FeesSubmitted;